import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Form, Icon, Input, Button, Spin, Alert, message, notification, Tooltip } from "antd";
import "./login.css";
import loginLogo from "./logo.png";
import axios from "axios";
import F from "../../Functions";

const FormItem = Form.Item;
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class ResetPassword extends Component {
  state = {
    loading: false,
    visible_pass: false,
    visible_confirm_pass: false,
    token: "",
  };
  componentDidMount = () => {
    window.document.body.classList.add("login");
    if (typeof this.props.match.params.token !== "undefined") {
      this.setState({ token: this.props.match.params.token });
    } else {
      this.props.history.push("/login");
      message.error(F.translate(`No password token found.`));
    }

    const passwordExpiry = localStorage.getItem('password_expiry');
    if (passwordExpiry) {
      notification.error({ message: passwordExpiry });
      localStorage.removeItem('password_expiry');
    }

    // if(window.password_expiry && window.password_expiry.length){
    //   notification.error({message:window.password_expiry})
    //   delete window.password_expiry
    // }
  };
  componentWillUnmount = () => {
    window.document.body.classList.remove("login");
  };
  compareToFirstPassword = (rule, value, callback) => {
    const form = this.props.form;
    if (value && value !== form.getFieldValue("password")) {
      callback("Confirmation password does not match the password.");
    } else {
      callback();
    }
  };
  send = (e) => {
    // reset notification
    message.destroy();
    const { history } = this.props;
    const { token } = this.state;

    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (values.password && !F.password_verify(values).password_length()) {
          message.error(F.translate(`Password should contain atleast 9 digits and not more than 20 digits.`));
          return false;
        }
        else if (values.password && !F.password_verify(values).complexity_equirements()) {
          message.error(F.translate('Password should contain Uppercase letters, Lowercase letters, Numbers and Special characters.'))
          return false;
        }
        this.setState({ loading: true });
        axios
          .post("/api/reset_password/" + token, {
            password: values.password,
          })
          .then((res) => {
            this.setState({ loading: false });
            if (res.data.success) {
              message.success(
                F.translate(`Password has been changed successfully.`)
              );
              history.push("/login");
            } else {
              if (!res.data.success) {
                message.error(res.data.message);
              } else {
                message.error(F.translate(`Can't update password.`));
              }

            }
          })
          .catch(() => {
            this.setState({ loading: false });
            message.error(F.translate(`Please try again later.`));
          });
      }
    });
  };

  toggleVisibility = (type) => {
    this.setState(prevState => ({
      visible_pass: type === 'password' ? !prevState.visible_pass : prevState.visible_pass,
      visible_confirm_pass: type === 'confirm_password' ? !prevState.visible_confirm_pass : prevState.visible_confirm_pass
    }));
  }

  render() {
    const { loading } = this.state;
    const { getFieldDecorator } = this.props.form;

    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh' // Full viewport height
      }}>
      <Form onSubmit={this.send} className="login-form forgot-password-form">
        <div className="login-form-header">
          <img src={loginLogo} alt="B File" />
        </div>
        <FormItem>
          {getFieldDecorator("password", {
            rules: [{ required: true, message: "Password field is required." }],
          })(
            <div style={{ display: "flex", alignItems: 'center', width: 312 }}>
              <Input
                prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
                type={this.state.visible_pass ? 'text' : 'password'}
                placeholder="Password"
                suffix={
                  <div>
                    <Icon
                      type={this.state.visible_pass ? 'eye-invisible' : 'eye'}
                      onClick={() => this.toggleVisibility('password')}
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                }
              />
              <Tooltip title="Password must be 9-20 characters, include at least 1 Uppercase character, 1 Lowercase character, 1 Numeric digit and a Special character.">
                <Icon
                  type="exclamation-circle-o"
                  style={{ color: "#1890ff" }} />
              </Tooltip>
            </div>
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator("confirm_password", {
            rules: [
              {
                required: true,
                message: "Confirm password field is required.",
              },
              {
                validator: this.compareToFirstPassword,
              },
            ],
          })(
            <Input
              prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
              type={this.state.visible_confirm_pass ? 'text' : 'password'}
              placeholder="Confirm Password"
              suffix={
                <Icon
                  type={this.state.visible_confirm_pass ? 'eye-invisible' : 'eye'}
                  onClick={() => this.toggleVisibility('confirm_password')}
                  style={{ cursor: 'pointer' }}
                />
              }
            />
          )}
        </FormItem>
        <FormItem>
          {loading ? (
            <Spin indicator={antIcon} />
          ) : (
            <div>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
              >
                Update Password
              </Button>
            </div>
          )}
        </FormItem>
      </Form>
      </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create()(ResetPassword);
export default WrappedNormalLoginForm;



// WEBPACK FOOTER //
// ./src/scenes/Login/reset-password.js